import { fromJS } from 'immutable';
import { createReducer } from 'utils/redux';
import * as actionTypes from './actionTypes';

const initialState = {
  submit: {
    fetching: false,
    data: null,
    error: null,
  },
  confirm: {
    fetching: false,
    data: null,
    error: null,
  },
  fetching: true,
};

const onSubmit = (state) =>
  state.setIn(['submit', 'fetching'], true).setIn(['submit', 'error'], null);

const onSubmitSuccess = (state, { payload }) =>
  state.setIn(['submit', 'data'], fromJS(payload)).setIn(['submit', 'fetching'], false);

const onSubmitError = (state, { payload }) => state.setIn(['submit', 'error'], fromJS(payload));

const onConfirm = (state) =>
  state.setIn(['confirm', 'fetching'], true).setIn(['confirm', 'error'], null);

const onConfirmSuccess = (state, { payload }) =>
  state.setIn(['confirm', 'data'], fromJS(payload)).setIn(['confirm', 'fetching'], false);

const onConfirmError = (state, { payload }) => state.setIn(['confirm', 'error'], fromJS(payload));

const onGetDraftSuccess = (state, { payload }) =>
  state.setIn(['draftData'], fromJS(payload)).setIn(['fetching'], false);

const onGetDraftFailure = (state, { payload }) =>
  state.setIn(['draftData', 'error'], fromJS(payload)).setIn(['fetching'], false);

const onGetDraft = (state) => state.setIn(['fetching'], true);

const onGetBankSuccess = (state, { payload }) =>
  state
    .setIn(['bankAccountOptions'], fromJS(payload))
    .setIn(['bankAccountOptions', 'fetching'], false);

const onGetBankFailure = (state, { payload }) =>
  state
    .setIn(['bankAccountOptions', 'error'], fromJS(payload))
    .setIn(['bankAccountOptions', 'fetching'], false);

const onGetBank = (state) => state.setIn(['bankAccountOptions', 'fetching'], true);

const onReset = () => fromJS(initialState);

export default createReducer(fromJS(initialState), {
  [actionTypes.INITIALIZE_SUCCESS]: onGetDraftSuccess,
  [actionTypes.INITIALIZE]: onGetDraft,
  [actionTypes.INITIALIZE_FAILURE]: onGetDraftFailure,

  [actionTypes.GETBANK_SUCCESS]: onGetBankSuccess,
  [actionTypes.GETBANK]: onGetBank,
  [actionTypes.GETBANK_FAILURE]: onGetBankFailure,

  [actionTypes.SUBMIT]: onSubmit,
  [actionTypes.SUBMIT_SUCCESS]: onSubmitSuccess,
  [actionTypes.SUBMIT_FAILURE]: onSubmitError,

  [actionTypes.CONFIRM]: onConfirm,
  [actionTypes.CONFIRM_SUCCESS]: onConfirmSuccess,
  [actionTypes.CONFIRM_FAILURE]: onConfirmError,

  [actionTypes.RESET]: onReset,
});
